// Auto-generated by scripts/bump-version.js during the prebuild step.
export const appVersion = '350';
